module.exports = __webpack_public_path__ + "media/truth_initiative_two/background-black_1200x1433-28ebd906.jpg";